import { Link } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";

// Driplee brand logo — uses optimized responsive WebP assets with crisp retina display and PNG fallback
export function DrippleeLogo({ size = 40, className = "" }) {
  const { theme } = useTheme();
  const isNight = theme === "night";

  // Scale the custom logo image to be larger so the icon and text are legible
  const displayHeight = Math.round(size * 2.25);
  const displayWidth = Math.round(displayHeight * (2000 / 1414));

  const mode = isNight ? "dark" : "light";
  const webp2x = `/driplee-logo-${mode}-240w.webp`;
  const webp1x = `/driplee-logo-${mode}-120w.webp`;

  return (
    <Link
      to="/"
      className={`inline-flex items-center cursor-pointer transition-opacity hover:opacity-85 focus:outline-none focus:ring-2 focus:ring-[#085450]/40 rounded-xl ${className}`}
      data-testid="driplee-logo-link"
      title="Driplee Home"
    >
      <picture>
        <source
          type="image/webp"
          srcSet={`${webp1x} 1x, ${webp2x} 2x`}
        />
        <img
          src={webp1x}
          srcSet={`${webp1x} 1x, ${webp2x} 2x`}
          alt="Driplee"
          width={displayWidth}
          height={displayHeight}
          fetchPriority="high"
          loading="eager"
          style={{ height: `${displayHeight}px`, width: "auto" }}
          className="object-contain"
        />
      </picture>
    </Link>
  );
}



